import LogoUrl from "../../img/BLUE.png";
import { Link } from "react-router-dom";
import MenuService from "../Menu/menuService";
import { useMediaQuery } from "@mui/material";

const Logo = () => {
  const ALT_TEXT = "Collecticos Logo";
  const matches = useMediaQuery("(min-width:768px)");

  const { selectPage } = MenuService();

  const handleClick = () => {
    selectPage("home");
  };

  const size = matches === true ? "260px" : "150px";

  return (
    <Link
      to={"/"}
      onClick={handleClick}
      style={{ display: "flex", alignItems: "center" }}
    >
      <img
        className="logoMenuMain"
        src={LogoUrl}
        alt={ALT_TEXT}
        style={{ width: size }}
      />
    </Link>
  );
};

export default Logo;
